import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import i18n from '~/i18n';
import App from './App';
import theme from '~/assets/theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { checkCurrentReactAppVersion } from './services/version';

checkCurrentReactAppVersion();

moment.locale(i18n.t('date:Locale'));
ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <App />
    </MuiPickersUtilsProvider>
  </MuiThemeProvider>,
  document.getElementById('root'),
);
